import { render, staticRenderFns } from "./masterawbdetails.vue?vue&type=template&id=64639808&"
import script from "./masterawbdetails.vue?vue&type=script&lang=js&"
export * from "./masterawbdetails.vue?vue&type=script&lang=js&"
import style0 from "./masterawbdetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports